/**
 * Manage upload multiple files from upload inputs
 */
export default class UploadManager {

    constructor(opts) {

        this._uploads = opts.uploads;
        this._uploadsArray = [];

        this._initialize();
    }

    /**
     * Initialize Upload Input class.
     */
    _initialize()
    {
        for (var item in this._uploads) {
            const input = this._uploads[item].input;
            const maxSize = this._uploads[item].maxSize;
            const type = this._uploads[item].type;
            const label = this._uploads[item].label;
            const required = this._uploads[item].required;
            this._uploadsArray.push(new UploadInput({ input, maxSize: maxSize, type: type, label: label, required: required }));
        }
    }

    getFiles()
    {
        this._process();

        this.values = [];
        for(var i = 0, j = this._uploadsArray.length; i < j; i++)
        {
            if(this._uploadsArray[i].isValid())
            {
                if(this._uploadsArray[i].getValue())
                    this.values[this._uploadsArray[i]._input.getAttribute("name")] = this._uploadsArray[i].getValue();
            } else
                return false;
        }

        return true;
    }

    getFilesValues()
    {
        return this.values;
    }

    _process() {
        for(var i = 0, j = this._uploadsArray.length; i < j; i++)
        {
            if(this._uploadsArray[i]._file)
                this._uploadsArray[i]._process();
        }
    }

    destroy() {
        for(var i = 0, j = this._uploadsArray.length; i < j; i++)
        {
            this._uploadsArray[i].destroy();
        }
    }

}

class UploadInput {

    constructor(opts) {

        this._input = opts.input;
        this._maxSize = opts.maxSize;
        this._type = opts.type;
        this._label = opts.label;
        this._required = opts.required;

        this._listeners = {};

        this._initialize();
    }

    _initialize() {

        this._listeners.change = function(e) {
            if ( this._input.files[0] ) {
                this._file = this._input.files[0];
                this._process();
            }
        }.bind(this);
        this._input.addEventListener('change', this._listeners.change);

        this._reset_btn = this._input.parentNode.querySelector( '.js-remove-file' );
        if( this._reset_btn ) {
            this._listeners.reset = (e) => {
                this._reset();
            };
        }
        this._reset_btn.addEventListener('click', this._listeners.reset);
    }

    _process() {
        // Check if a file is uploaded
        this._clearClasses();

        if( this._file ) {

            var container = this._input.parentNode;
            container.classList.remove( 'success' );

            this._size = this._file.size/(1024*1024);
            // Check if file follow upload restrictions (maxSize + type)
            if( this._size <= this._maxSize )
            {
                this._label.classList.remove('error-size');
                this._valid = false;
                for( var el in this._type )
                {
                    if(this._type[el] == this._file.type) {
                        this._valid = true;

                        var filename = container.querySelector( '.label-filename' );
                        container.classList.add( 'success' );
                        filename.innerHTML = this._file.name;
                    }
                }
                if(this._valid == false)
                    this._label.classList.add('error-type');
                else {
                    this._label.classList.remove('error-type');
                    this._label.classList.add('validate');
                }

            } else {
                this._label.classList.add('error-size');
            }

        } else {
            if( this._required == true )
                this._valid = false;
            else {
                this._valid = true;
            }
        }

    }

    _clearClasses() {
        this._label.classList.remove('validate');
        this._label.classList.remove('error-size');
        this._label.classList.remove('error-type');
    }

    _reset() {
        this._input.value = null;
        this._file = null;
        var container = this._input.parentNode;
        container.classList.remove( 'success' );
        if( this._required == true )
            this._valid = false;
        else
            this._valid = true;
    }

    isValid() {
        if(this._required == true || typeof this._file != 'undefined')
            return this._valid;
        else
            return true;
    }

    getValue() {
        if(this._file)
            return this._file;
    }

    destroy() {
        this._input.removeEventListener('change', this._listeners.change);
        this._listeners = {};
    }
}


// WEBPACK FOOTER //
// src/js/helpers/upload-manager.js